import { render, staticRenderFns } from "./marquee-tino.vue?vue&type=template&id=5b45c6ec&scoped=true&"
import script from "./marquee-tino.vue?vue&type=script&lang=js&"
export * from "./marquee-tino.vue?vue&type=script&lang=js&"
import style0 from "./marquee-tino.vue?vue&type=style&index=0&id=5b45c6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45c6ec",
  null
  
)

export default component.exports